"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../hooks");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props) {
  var _props$display = props.display,
    display = _props$display === void 0 ? 'block' : _props$display;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccCheckboxGroupStyle = (0, _react.useMemo)(function () {
    var displayProps = function displayProps() {
      var flexDirection = display === 'inline' ? 'row' : 'column';
      return {
        flexDirection: flexDirection
      };
    };
    var cbDisplayProps = function cbDisplayProps() {
      var marginInlineEnd = display === 'inline' ? pxToRem(20) : pxToRem(0);
      var marginBlockStart = display === 'inline' ? pxToRem(0) : pxToRem(12);
      return {
        marginInlineEnd: marginInlineEnd,
        marginBlockStart: marginBlockStart
      };
    };
    var ccCheckboxGroup = (0, _css.css)(_objectSpread(_objectSpread({
      display: 'flex'
    }, displayProps()), {}, {
      '& > div': _objectSpread({}, cbDisplayProps()),
      '& > div:first-child': {
        marginBlockStart: 0
      }
    }));
    return ccCheckboxGroup;
  }, [display, pxToRem]);
  return {
    'cc-CheckboxGroup': ccCheckboxGroupStyle
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;